import { EnvProfile } from "./types";

export const localProfile: EnvProfile = {
  uiHostUrl: "http://localhost",
  apiHostUrl: "http://localhost:8080/api/v1",
  freshdeskUrl: "https://testcompany3698.freshdesk.com/",
  queryCachingSeconds: 0
};
